import React from 'react'
import { MobilePaginationBar } from '../components/mobile'

const PosTaskMobilePagination = ({ pagination, onPageChange }) => (
  <MobilePaginationBar
    current_page={pagination?.current_page}
    total_pages={pagination?.total_pages}
    onPageChange={onPageChange}
    ariaLabel="Paginación de tareas en punto de venta"
    disablePaper
  />
)

export default PosTaskMobilePagination
